import {setThreads, setThreadsLoading, setThreadsError} from './chatSlice';

/**
 * Loads conversation threads from `GET /insights/threads` into Redux (same request as History panel).
 * @param {function(Object): void} dispatch - Redux dispatch
 * @return {Promise<void>}
 */
export async function fetchInsightsThreadsList(dispatch) {
  dispatch(setThreadsLoading(true));
  dispatch(setThreadsError(null));

  try {
    const response = await fetch('/insights/threads', {
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch threads');
    }

    const data = await response.json();
    dispatch(setThreads(data.threads || []));
  } catch (error) {
    console.error('Failed to load threads:', error);
    dispatch(setThreadsError(error.message));
  } finally {
    dispatch(setThreadsLoading(false));
  }
}
